import React, { useEffect, useState } from 'react';
import connect from "react-redux/es/components/connect";
import { useNavigate } from "react-router-dom";
import Box from '@mui/system/Box';
import {
    FormControl, AccordionSummary, Accordion, AccordionDetails, Typography,
    Select, MenuItem, TextField, Button
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { actionGetVFASPClientList } from "../store/action/RemoteActionSupervisor";
import translate from "../i18n/translate";
import { resetTimout } from "./common/FirebaseSupervisor";

const ClientList = (props) => {
    const navigate = useNavigate();
    const [message, setMessage] = useState("");
    const [language, setLanguage] = useState("");
    const [isError, setIsError] = useState(false);
    const [searchField, setSearchField] = useState(0);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [clientList, setClientList] = useState([]);

    const Message = ({ message }) => (
        <section>
            <p style={{ color: isError ? "red" : "blue" }}>{message}</p>
        </section>
    );

    const onClickSearch = () => {
        resetTimout();
        const requestBody = {
            SearchField: searchField,
            SearchKeyword: searchKeyword
        };
        props.actionGetVFASPClientList(requestBody);
    };

    const handleChange = (e) => {
        resetTimout();
        let eventValue = e.target.value;
        switch (e.target.name) {
            case "search-field":
                eventValue = parseInt(eventValue);
                setSearchField(eventValue);
                if (eventValue === 0) {
                    setSearchKeyword("");
                }
                break;
            case "search-keyword":
                setSearchKeyword(eventValue);
                break;
            default:
                console.log(e.target.name);
        }
    };

    const goToModiyClient = (sClientID) => {
        resetTimout();
        navigate('/modifyclient?CID=' + sClientID);
    };

    useEffect(() => {
        if (props?.clientList?.length > 0) {
            setClientList(props.clientList);
        }
    }, [props.clientList]);

    useEffect(() => {
        setLanguage(localStorage.getItem("locale"));
        const requestBody = {
            SearchField: 0,
            SearchKeyword: ''
        };
        props.actionGetVFASPClientList(requestBody);
    }, []);

    return (
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-ClientList')}</h2>
            {/* if there is no transaction you can use this code */}
            {message ? (
                <Message message={message} />
            ) : ''}

            <Box sx={{ display: 'flex' }}>
                <Accordion sx={{ display: 'nowrap', marginBottom: '10' }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography>{translate('Filters')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormControl required component="fieldset" sx={{ m: 3, width: 250 }} variant="standard">
                            <Select id="search-field" name="search-field" value={searchField} label={translate('SearchField')} onChange={handleChange}>
                                <MenuItem value={0}><em>{translate('Select-SearchField')}</em></MenuItem>
                                <MenuItem value={1}>{translate('ClientID')}</MenuItem>
                                <MenuItem value={2}>{translate('MailID')}</MenuItem>
                                <MenuItem value={3}>{translate('ClientName')}</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl required component="fieldset" sx={{ m: 3, width: 250 }} variant="standard">
                            <TextField id="search-keyword" name="search-keyword" value={searchKeyword} label={translate('SearchKeyword')} variant="outlined" size="small" onChange={handleChange} />
                        </FormControl>

                        <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                            <Button variant="contained" onClick={() => onClickSearch()}>{translate('btnSearch')}</Button>
                        </FormControl>
                    </AccordionDetails>
                </Accordion>
            </Box>

            <div className="gaps-3x" />
            {/* Vfasp/Client List Table */}
            <table className="adminTable" style={{ width: 890 }}>
                <tbody>
                    <tr className="adminTR">
                        <th className="adminTH" style={{ width: '12%' }}>{translate('ClientID')}</th>
                        <th className="adminTH" style={{ width: '24%' }}>{translate('MailID')}</th>
                        <th className="adminTH" style={{ width: '22%' }}>{translate('ClientName')}</th>
                        <th className="adminTH" style={{ width: '13%' }}>{translate('UserLogin')}</th>
                        <th className="adminTH" style={{ width: '13%' }}>{translate('AdminLogin')}</th>
                        <th className="adminTH" style={{ width: '16%' }}>{translate('CreatedDate')}</th>
                    </tr>
                    {clientList?.map((client, index) => {
                        return <tr className="adminTR" key={client.AUTORECID}>
                            <td className="adminTD" width='12%' align='left'><a href='#' onClick={event => goToModiyClient(client.ClientID)}>{client.ClientID}</a></td>
                            <td className="adminTD" width='24%' align='left'>{client.MailID}</td>
                            <td className="adminTD" width='22%' align='left'>{client.ClientName}</td>
                            <td className="adminTD" width='13%' align='center'>{(client.IsUserLogin === 1) ? translate('Status-Active') : translate('Status-InActive')}</td>
                            <td className="adminTD" width='13%' align='center'>{(client.IsAdminLogin === 1) ? translate('Status-Active') : translate('Status-InActive')}</td>
                            <td className="adminTD" width='16%' align='center'>{client.DateCreated}</td>
                        </tr>
                    })
                    }
                </tbody>
            </table>

        </div>

    );
};

const mapStateToProps = state => {
    return {
        clientList: state.remote.clientList
    };
};

export default connect(mapStateToProps, {
    actionGetVFASPClientList
})(ClientList);
